import { Link } from "react-router-dom";
import { SiteShell } from "@/components/site/SiteShell";
import { PageHero } from "@/components/site/PageHero";
import { SEO, breadcrumbSchema } from "@/components/site/SEO";
import { Film, Tv, Briefcase, Scissors, Camera, Video, Layers, Megaphone, Clapperboard, Sparkles, Users, HardHat, ArrowUpRight } from "lucide-react";
import { SERVICES_OVERVIEW } from "@/lib/siteData";
import { ROUTE_SEO } from "@/lib/routeSeo";

const ICONS = { Film, Tv, Briefcase, Scissors, Camera, Video, Layers, Megaphone, Clapperboard, Sparkles, Users, HardHat };

export default function ServicesHub() {
  return (
    <SiteShell>
      <SEO
        title={ROUTE_SEO["/services"].title}
        description={ROUTE_SEO["/services"].meta}
        path="/services"
        jsonLd={breadcrumbSchema([{name: "Home", path: "/"}, {name: "Services"}])}
      />
      <PageHero kicker="Services" title={ROUTE_SEO["/services"].h1} subtitle="A senior video production company in Cape Town - from concept and capture to finishing and rollout." breadcrumb={[{name: "Home", path: "/"}, {name: "Services"}]} />
      <section className="section-pad">
        <div className="container-site">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border rounded-2xl overflow-hidden border border-border">
            {SERVICES_OVERVIEW.map(s => {
              const Icon = ICONS[s.icon] || Film;
              return (
                <Link key={s.id} to={s.slug} data-testid={`services-hub-card-${s.id}`} className="group block bg-card p-8 sm:p-10 hover:bg-[hsl(225,18%,9%)] transition-colors">
                  <div className="flex items-start justify-between">
                    <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[hsl(225,16%,14%)] border border-border text-[hsl(var(--primary))]"><Icon className="h-5 w-5" /></div>
                    <ArrowUpRight className="h-5 w-5 text-muted-foreground opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                  </div>
                  <h3 className="mt-8 font-display text-2xl uppercase tracking-[0.02em] text-foreground">{s.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </SiteShell>
  );
}
